import { useCallback } from 'react';

import type { Id } from '@e-socna/data-layer';

import { printSettingsForm2ApiMapper } from '../../../components/DocumentEditor/mappers/print-settings.form2api.mapper';
import type { OnSavePrintSettingsHandler } from '../../../components/DocumentEditor/types/props.type';

import { useUpdateSectionTemplatePrintSettingsMutation } from './useUpdatePrintSettingsMutation.hook';
import { useQueryInvalidation } from './useQueryInvalidation.hook';

interface Params {
  readonly sectionTemplateId: Id;
}

export const useSavePrintSettingsHandler = ({
  sectionTemplateId,
}: Readonly<Params>) => {
  const { invalidateQueries } = useQueryInvalidation(sectionTemplateId);
  const { mutateAsync: updatePrintSettings } =
    useUpdateSectionTemplatePrintSettingsMutation();

  const onSavePrintSettings = useCallback<OnSavePrintSettingsHandler>(
    async (printSettings) => {
      await updatePrintSettings({
        printableId: sectionTemplateId,
        printSettings: printSettingsForm2ApiMapper(printSettings),
      });
      invalidateQueries();
    },
    [invalidateQueries, sectionTemplateId, updatePrintSettings],
  );

  return { onSavePrintSettings };
};
